import * as _ from "lodash";

export const objectToQueryString = (requestedParams: any) => {
  let queryString = "";
  const validParams = _.omitBy(
    requestedParams,
    (v: any) =>
      _.isUndefined(v) ||
      _.isNull(v) ||
      v === "" ||
      (Array.isArray(v) && v.length === 0)
  );
  const keys = Object.keys(validParams);
  for (let key of keys) {
    const value = validParams[key];
    if (Array.isArray(value)) {
      queryString += `${encodeURIComponent(key)}=[${value
        .map(encodeURIComponent)
        .join(",")}]&`;
    } else {
      queryString += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
    }
  }
  return queryString.slice(0, -1);
};
